// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - DIALOG ||============================== //

// Mantém o mesmo comportamento que você tinha em src/themes/index.tsx:
// apenas controla o "paper" do Dialog, deixando o backdrop/blur global
// a cargo do override de Backdrop.
export default function Dialog(theme: Theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundImage: `${theme.customGradients.paperBg} !important`,
          backgroundColor: `${theme.palette.grey[0]} !important`,
          borderRadius: theme.shape.borderRadius
        }
      }
    }
  };
}
